<template>
  <div class="goodsDetail">
      <el-dialog
        title="图片查看"
        :visible.sync="dialogVisible"
        width="60%"
        top="25px"
        >
        <div>
          <img :src="dialogImg"  style="width: 100%;"/>
        </div>
    </el-dialog>
    <div class="layer">
      <Search />
    </div>
    <div class="layer">
        <SuperNav :list="data.headerNav"/>
    </div>
    <div class="nav_bottom"></div>
    <div class="layer exhibition mt15 mb50">
      <div class="left pr">
        <!--<div class="pa remark">温馨提示: 图片均为固德医药对原品的真实拍摄，如遇新包装上市可能存在上新滞后，请以实物为准。</div>-->
        <div class="imgBox">
            <image-magnifier :src="'https://api.goodyiyao.cn/' + bigImg"
              v-if="formValue.original_img !== ''"
              v-show="imgShow"
              :zoom-src="'https://api.goodyiyao.cn/' + bigImg"
              zoom-width="300"
              zoom-height="300">
            </image-magnifier>
            <img id="cloneIMG" :src="'https://api.goodyiyao.cn/' + formValue.original_img" @load="imgResize" style="visibility:hidden"/>
        </div>
        <div class="imgList">
          <div class="imgItem" @click="changeShowImg(formValue.cloneOriginal_img)">
            <img :src="'https://api.goodyiyao.cn/' + formValue.cloneOriginal_img"/>
          </div>
          <div class="imgItem" v-for="item in formValue.images" :key="item.img_id" @click="changeShowImg(item.image_url)">
            <img :src="'https://api.goodyiyao.cn/' + item.image_url" />
          </div>
        </div>
      </div>
      <div class="right">
          <div class="title">{{ formValue.common_name }}<span v-if="formValue.goods_name!==''">({{ formValue.goods_name }})</span> <el-tag class="csp" style="vertical-align: middle;margin-left: 5px;" @click="gotoDownload" v-if="certificateStatus === 2 &&haveBatch">下载资质批号</el-tag></div>
          <div class="detail">{{ formValue.goods_remark }}</div>
          <!--<div class="price colorRed item">
            <div class="mtitle">零售价</div><div>:</div>
            <div class="pricebox">￥{{ formValue.market_price }}</div>
            <div v-if="formValue.give_integral" class="activitybox">购买商品获得{{ formValue.give_integral }}积分</div>
            <div v-if="formValue.give_integral" class="activitybox">抵扣{{ formValue.give_integral }}积分</div>
          </div>-->
          <div class="item identifier">
            <div class="mtitle">商品编号</div><div class="colon">:</div>
            <div>{{ formValue.goods_code }}</div>
          </div>
          <div class="item company">
            <div class="mtitle">生产厂家</div><div class="colon">:</div>
            <div>{{ formValue.manufacturer_name }}</div>
          </div>
          <div class="item symbol">
            <div class="mtitle">批准文号</div><div class="colon">:</div>
            <div>{{ formValue.approval_number }}</div>
          </div>
          <!-- <div class="item saleNum">
            <div class="mtitle">限购</div><div class="colon">:</div>
            <div>{{ formValue.limit }}件</div>
          </div> -->
          <!--<div class="item saleNum">-->
            <!--<div class="mtitle">近期销量</div><div class="colon">:</div>-->
            <!--<div>{{ formValue.sales_sum }}</div>-->
          <!--</div>-->
          <div class="item type">
            <div class="mtitle">处方类型</div><div class="colon">:</div>
            <div>{{ formValue.medicinename }}</div>
          </div>
          <!--<div class="item purchasePrice">
            <div class="mtitle">采购价</div><div class="colon">:</div>
            <div class="colorRed" v-text="formValue.wholesale_price==='登录可见'?'登录可见':'￥'+ formValue.wholesale_price"></div>
          </div>-->
          <div class="item specifications">
            <div class="mtitle">规格</div><div class="colon">:</div>
            {{ formValue.goods_spec }}
          </div>
          <!--<div class="item amount">
            <div class="mtitle">数量</div><div class="colon">:</div>
            <div class="td-amount"><el-input-number size="mini" :min="1" :max="formValue.store_count" v-model="amount" style="height:29px;"></el-input-number></div>
            <div>库存{{ formValue.store_count }}件</div>
          </div>-->
          <!--<div class="item buy">
            <div><button type="button" class="el-button el-button&#45;&#45;primary" @click="addCart">加入购物车</button></div>
            <div class="Collection" :class="is_collect === true ? 'isCollect' : ''" @click="changeCollect"><i class="el-icon-star-on"></i><span v-text="is_collect === true ? '取消收藏' : '加入收藏夹'"></span></div>
            &lt;!&ndash; <div class="collection csp" :class="good.collection === true ? 'collectionTrue' : ''" ><span v-if="good.collection" class="colorRed mr5">已收藏</span><span v-else>收藏</span><i class="iconxin iconfont f20 colorRed" v-show="good.collection"></i></div> &ndash;&gt;
          </div>-->
          <!-- <div class="item promise">
            <div class="mtitle">承诺</div><div class="colon">:</div>
            <div v-for="(item,index) in good.promise" :key="index" class="promisebox">{{ item }}</div>
          </div> -->
      </div>
      <good-detail-swiper :swiperData="swiperData"></good-detail-swiper>
    </div>
    <!--<div class="layer">
      <SmallBanner :prop="banner"  class="mt15"/>
    </div>-->
    <div class="layer detail bottom">
      <div class="left">
          <CommdityLeft :prop="commdity1" />
      </div>
      <div class="right">
        <div class="content">
          <div class="tabTop">
            <div class="tab">商品说明书</div>
          </div>
 
              <div class="tabContent">
                <el-row>
                  <el-col :span="12">
                    <div class="item">
                      <div class="mtitle">成分:</div>
                      <div class="text">{{ formValue.component }}</div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="item">
                      <div class="mtitle">功能主治:</div>
                      <div class="text">{{ formValue.management }}</div>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <div class="item">
                      <div class="mtitle">用法用量:</div>
                      <div class="text">{{ formValue.dosage }}</div>
                    </div>
                  </el-col>
                   <el-col :span="12">
                    <div class="item">
                      <div class="mtitle">不良反应:</div>
                      <div class="text">{{ formValue.adverse_reaction }}</div>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <div class="item">
                      <div class="mtitle">症状:</div>
                      <div class="text">{{ formValue.character }}</div>
                    </div>
                  </el-col>
                   <el-col :span="12">
                    <div class="item">
                      <div class="mtitle">禁忌:</div>
                      <div class="text">{{ formValue.taboo }}</div>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <div class="item">
                      <div class="mtitle">注意事项:</div>
                      <div class="text">{{ formValue.attentions }}</div>
                    </div>
                  </el-col>
                   <el-col :span="12">
                    <div class="item">
                      <div class="mtitle">药物相互作用:</div>
                      <div class="text">{{ formValue.interaction }}</div>
                    </div>
                  </el-col>
                </el-row>
                 <el-row>
                   <el-col :span="12">
                    <div class="item">
                      <div class="mtitle">包装:</div>
                      <div class="text">{{ formValue.packing }}</div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="item">
                      <div class="mtitle">贮藏:</div>
                      <div class="text">{{ formValue.storage }}</div>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                   <el-col :span="24">
                    <div class="item">
                      <div class="mtitle">有效期:</div>
                      <div class="text">{{ formValue.shelf_life }}</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
          <div class="tabTop">
            <div class="tab">商品展示</div>
          </div>
          <div style="text-align: center;">
            <img :src="'https://api.goodyiyao.cn/' + formValue.original_img" @click="showDialogImg(formValue.original_img)"/>
          </div>
          <div v-for="item in formValue.images" :key="item.img_id" style="text-align:center;">
            <img :src="'https://api.goodyiyao.cn/' + item.image_url" @click="showDialogImg(item.image_url)" />
          </div>
          <!--<div class="tabTop">-->
            <!--<div class="tab">温馨提示</div>-->
          <!--</div>-->
          <!--<el-row style="margin-top: 35px;border: 2px solid #ccc;padding: 8px 15px;box-shadow: 0 0 0 3px #eee">-->
            <!--1、商品图片信息展示仅供参考，最终包装以商品实物为准。欢迎纠错！<br/>-->
            <!--2、说明书内容仅供查阅参考，最终以商品包装内说明书为准。欢迎纠错！<br/>-->
            <!--3、使用商品时，请仔细阅读说明书，并按说明书使用！<br/>-->
            <!--4、药品请按说明书或在医师或药师指导下购买和使用！<br/>-->
            <!--5、医疗器械产品请仔细阅读产品说明书或者在医务人员的指导下购买和使用，禁忌内容或者注意事项详见说明书！<br/>-->
            <!--6、保健食品不能代替药物！-->
          <!--</el-row>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search/index'
import goodDetailSwiper from './goodDetailSwiper'
import SuperNav from '@/components/SuperNav/index'
//import SmallBanner from '@/components/Banner/smallBanner'
import CommdityLeft from '@/components/CommdityList/commdityLeft'
import { GoodsService } from '../../service/goods.service'
//import { UserCenterService } from '../../service/userCenter.service'
import { ImageMagnifier } from 'vue-image-magnifier'
import $ from 'jquery'
  export default {
    name: 'goodDetail',
    data() {
      return{
        is_active: 'first',
        banner: [{
          src: 'https://api.goodyiyao.cn/static/upload/other/smallBanner.jpg'
        }],
        formValue: {},
        amount: 1,
        commdity1: [{
          title: "热门推荐",
          commdity: []
        }],
        imgShow: false,
        goodsId: '',
//        token: Boolean,
        dialogImg: '',
        dialogVisible: false,
        certificateStatus: NaN,
        swiperData:[]
      }
    },
    computed: {
      is_collect:{
        get() {
          return this.formValue.is_collect
        },
        set(value) {
          this.formValue.is_collect = value
        }
      },
      bigImg() {
        return GoodsService.bigImg(this.formValue.original_img)
      },
      data() {
          return this.$store.getters.shop_index
      }
    },
    components: {
        Search,
        SuperNav,
//        SmallBanner,
        ImageMagnifier,
        CommdityLeft,
        goodDetailSwiper
    },
    async created() {
      this.goodsId = this.$router.currentRoute.params.goodsId
//      this.token = await UserCenterService.checkToken();
      this.getList();
    },
    beforeRouteUpdate(to, from, next) {
      if (to.name === from.name) {
        this.goodsId = to.params.goodsId
        this.getList();
      }
      next();
    },
    methods: {
      async getList() {
          const data = await GoodsService.goodsDetail(this.goodsId)
          this.certificateStatus = data.is_apply;
          this.haveBatch = data.is_batch;
          this.swiperData = data.similarGoods
          this.commdity1[0].commdity = JSON.parse(JSON.stringify(data.hotGoods))
          this.formValue = JSON.parse(JSON.stringify(data))
          if(data.common_name.indexOf('（')>0||data.common_name.indexOf('(')>0) {
            this.formValue.goods_name = ''
          }
          this.formValue.original_img = GoodsService.thumbImg(this.formValue.original_img)
          this.formValue.images.forEach(val=>{
            val.image_url = GoodsService.thumbImg(val.image_url)
          })
          this.formValue.cloneOriginal_img = this.formValue.original_img
      },
      async changeCollect() {
        if(!this.is_collect) {
          try{
            const data = await GoodsService.addCollect(this.$router.currentRoute.params.goodsId)
            this.formValue.collect_id = data
            this.is_collect = true
          }catch(e) {
            console.log(e)
          }
        }else{
          try{
            await GoodsService.removeCollect(this.formValue.collect_id)
            this.is_collect = false
          }catch(e) {
            console.log(e)
          }
        }
      },
      showDialogImg(val) {
        this.dialogVisible = true
        this.dialogImg = 'https://api.goodyiyao.cn/'+GoodsService.bigImg(val)
      },
      gotoDownload() {
        let url = `/#/download?goods_id=`+this.goodsId+`&good_name=`+this.formValue.goods_name
        window.open(url,"下载", "height=754, width=1277, top=100, left=100, toolbar=no, menubar=no, scrollbars=no, resizable=yes,location=no, status=no");
      },
      async addCart() {
        try{
          const data = await GoodsService.addCart(this.$router.currentRoute.params.goodsId,this.amount)
          this.$store.commit('calculationNumber',data)
          this.$message({
            message: '添加成功',
            type: 'success'
          });

        }catch(e) {
          console.log(e)
        }
      },
      imgResize() {
        let imgW = $('#cloneIMG').width()
        let imgH = $('#cloneIMG').height()
        let boxW = $('.imgBox').width()
        let boxH = $('.imgBox').height()
        if((imgW/imgH)<=(boxW/boxH)) {
          $('.image-magnifier__img').css({height:boxH,width:'auto',left:'50%',top:'0',transform:'translate(-50%,0)'})
          this.imgShow = true
          $('.image-magnifier__mask').css({marginLeft:boxW/2-imgW/(imgH/boxH)/2,marginTop:0,width:150,height:150})
          $('.image-magnifier__zoom').css({marginLeft:boxW/2-imgW/(imgH/boxH)/2,marginTop:0,width:500,height:500})
        }else{
          $('.image-magnifier__img').css({width:boxW,height:'auto',top:boxH/2,transform:'translate(0,-50%)',left:"0"})
          this.imgShow = true
          $('.image-magnifier__mask').css({marginTop:(boxH-(imgH/(imgW/boxW)))/2,marginLeft:0})
          $('.image-magnifier__zoom').css({marginTop:0,marginLeft:0})
        }
      },
      changeShowImg(val) {
        this.imgShow = false
        this.formValue.original_img = val
      }
    }
  }
</script>

<style lang="scss" scoped>
.image-magnifier{
  display: block!important;
}
.tabTop {
  padding: 0 18px;
  height: 40px;
  border-bottom: 2px solid #2E98D5;
  display: flex;
  justify-content: flex-start;
  .tab {
    height: 100%;
    background: #2E98D5;
    color: #fff;
    
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    font-size: 14px;
    margin-right: 20px;
  }
}
.goodsDetail {
  width: 100%;
  .exhibition{
    display: flex;
    justify-content: flex-start;
    .left{
      width: 440px;
      .remark{
        bottom: -40px;
        color: #666;
      }
      .imgBox{
        width: 440px;
        height: 440px;
        border: 1px solid #eee;
      }
      .imgList{
        display: flex;
        .imgItem{
          margin-top: 20px;
          width: 60px;
          height: 60px;
          border: 2px solid #bebebe;
          cursor: pointer;
          img{
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .imgItem:not(:first-of-type){
          margin-left: 10px;
        }
        .imgItem:hover{
          border-color: #e83c24;
        }
      }
      
    }
    .right{
      width: 620px;
      margin-left: 50px;
      font-size: 14px;
      .title{
        font-size: 26px;
        font-weight: 700;
      }
      .detail{
        border-bottom: 1px dashed #ddd;
        line-height: 40px;
      }
      .Collection{
        line-height: 40px;
        font-size: 14px;
        cursor: pointer;
        i{
          font-size: 22px;
          vertical-align: middle;
        }
      }
      .Collection.isCollect{
        color: #f50;
      }
      .item{
        display: flex;
        flex-direction: row;
        /*height: 20px;
        line-height: 20px;*/
        height: 40px;
        line-height: 40px;
        margin-top: 10px;
        font-size: 16px;
        .mtitle{
          width: 80px;
          text-align: justify;
        }
        .mtitle::after{
          content:'';
          width: 100%;
          display: inline-block;
          overflow: hidden;
          height: 0;
        }
        .colon{
          margin-right: 15px;
        }
        .collection{
          line-height: 60px;
        }
      }
      .price{
        margin-top: 25px;
        .pricebox{
          font-size: 30px;
          margin: -5px 15px 0 8px;
        }
        .activitybox{
          background: #f7e4e3;
          height: 25px;
          line-height: 25px;
          padding:  0 8px;
          margin-right: 15px;
          border-radius: 5px;
          display: block;
          margin-top: -5px;
        }
      }
      .purchasePrice{
        padding-bottom: 15px;
        border-bottom: 1px dashed #ddd;
      }
      .specifications{
        margin-top: 15px;
      }
      .buy{
        height: 40px;
        margin-top: 25px;
        margin-left: 18px;
        .el-button{
          font-size: 16px;
          margin-right: 15px;
          padding: 0!important;
          width: 120px;
          height: 40px;
          line-height: 40px;
        }
      }
      .amount{
        margin-top: 30px;
        .td-amount{
          margin:-3px 8px 0 0;
        }
      }
      .promise{
        height: 40px;
        line-height: 40px;
      }
      .promisebox{
        background: url('../../assets/images/icon/checkedIcon.png') left center no-repeat;
        text-indent:35px;
        margin-right: 10px;
      }
    }
  }
}
.bottom{
    .right{
       /deep/ .el-tabs__header{
        padding: 0 20px;
      }
    }
  }
.bottom{
  margin-top: 45px;
  display: flex;
  .left{
    width: 250px;
  }
  .right{
    width: 950px;
    border: 1px solid #eee;
    .tabContent{
      padding: 15px; 
      font-size: 14px;
      .item{
        display: flex;
        line-height: 35px;
        .mtitle{
          font-weight: 700;
          margin-right: 15px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
  .bottom{
    .right{
      #tab-first{
        padding-left: 20px;
      }
      .el-tabs__header.is-top{
        background: #f7f7f7;
      }
    }
  }
  .goodsDetail{
    .item{
      .el-radio--mini{
        padding: 6px 15px 0 15px;;
        border-color: #bfbfbe;
        color: #666;
        margin-right: 8px;
        .el-radio__input{
          display: none;
        }
        .el-radio__label{
          padding-left: 0;
        }
      }
      .el-radio.is-checked{
        border-color: #e83c24;
        background: url('../../assets/images/icon/checked.png') right bottom no-repeat;
        .el-radio__label{
          color: #666;
        }
      }
    }
  }
</style>